/**
 * Call-back request — /book, under the Zoho Bookings iframe, for visitors
 * who can't find a slot. Partner Programme consultations land in the Partner
 * layout as partner enquiries; everything else is a booking fallback.
 */
import { company, email, fullName, phoneRequired } from "./common";

const PARTNER = "partner";

const CONSULTATION_OPTIONS = [
  { value: "merchant_savings", label: "Merchant Savings Review" },
  { value: "new_business", label: "New Business Consultation" },
  { value: PARTNER, label: "Partner Programme Consultation" },
  { value: "ecommerce", label: "E-Commerce Payments Consultation" },
  { value: "general", label: "General Enquiry" },
];

/** Consultation → Zoho Needs (multiselect, so always an array). */
const CONSULTATION_NEEDS = { ecommerce: ["Online payments"] };

const CALLBACK_TIMES = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "any", label: "Any time" },
];

const labelOf = (options, value) => options.find((o) => o.value === value)?.label;

const callbackRequest = {
  id: "callback_request",
  label: "Call-back request",
  crm: {
    layout: (values) => (values.consultation_type === PARTNER ? "Partner" : "Standard"),
    leadSource: (values) =>
      values.consultation_type === PARTNER ? "Website Partner Enquiry" : "Website Booking Fallback",
    leadSourceOptions: ["Website Partner Enquiry", "Website Booking Fallback"],
    tags: [],
  },
  fields: [
    [fullName, company],
    [email, phoneRequired],
    {
      name: "consultation_type", type: "radio", label: "What would you like to talk about?", required: true,
      requiredMessage: "Please choose what you'd like to talk about", answerLabel: "Consultation type",
      options: CONSULTATION_OPTIONS,
      crm: (value) => ({ Needs: CONSULTATION_NEEDS[value] || [] }),
    },
    {
      name: "callback_time", type: "radio", label: "Best time to call", answerLabel: "Preferred call-back time",
      options: CALLBACK_TIMES,
    },
    {
      name: "notes", type: "textarea", label: "Notes (optional)", crm: "Description", maxLength: 2000, rows: 3,
      placeholder: "Anything you'd like us to know?",
    },
  ],
  submitLabel: "Request a call back",
  consent: { variant: "standard" },
  success: {
    title: "Thanks — we'll call you back",
    body: "We've received your details and will call you within 2 business hours.",
  },
  summary: (values) =>
    [
      "Call-back request",
      labelOf(CONSULTATION_OPTIONS, values.consultation_type),
      labelOf(CALLBACK_TIMES, values.callback_time),
    ].filter(Boolean).join(" · "),
};

export default callbackRequest;
